import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import { GetSchoolUnit } from '../../../store/SchoolAction';
import * as SchoolTypeUtil from '../../../util/SchoolTypeUtil';
import * as Helper from '../../../util/Helper';
import StatusCode from '../../../util/StatusCode';
import TableVertical, { TableVerticalInfoObject } from '../../misc/TableVertical';
import { CoreSchoolUnit } from '../../../models/CoreSchoolUnit';
import { RequestState } from '../../../models/RequestState';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/store';



const SchoolUnitViewInfo = () => {
    const { t } = useTranslation(['common']);
    const { schoolId } = useParams();

    const dispatch = useDispatch();
    const school = useSelector<RootState, RequestState<CoreSchoolUnit>>(state => state.schools.school);

    useEffect(() => {
        if (schoolId !== undefined) {
            GetSchoolUnit(schoolId)(dispatch);
        }
    }, [dispatch, schoolId]);

    const renderSchoolUnitInfo = () => {
        const schoolInfo: TableVerticalInfoObject[] = [];
        if (school.code === StatusCode.COMPLETE) {
            const s = school.data;
            schoolInfo.push(
                { header: t('commonTableHeaders.title', { ns: 'schoolAdministration' }), content: s.title },
                { header: t('schoolViewInformationTableHeaders.shortName', { ns: 'schoolAdministration' }), content: s.shortName },
                { header: t('genericTableHeaders.id', { ns: 'common' }), content: s.id },
                { header: t('commonTableHeaders.schoolType', { ns: 'schoolAdministration' }), content: SchoolTypeUtil.getTranslationKeys(s.schoolTypes?.id ?? 0).map(k => t(k, { ns: 'common' })).join(', ') },
                { header: t('genericTableHeaders.startDate', { ns: 'common' }), content: Helper.formatDateOnly(s.startDate) },
                { header: t('genericTableHeaders.endDate', { ns: 'common' }), content: Helper.formatDateOnly(s.endDate) },
                { header: t('schoolViewInformationTableHeaders.municipalityCode', { ns: 'schoolAdministration' }), content: s.municipalityCode },
                { header: t('schoolViewInformationTableHeaders.organisation', { ns: 'schoolAdministration' }), content: s.organisation?.title },
                { header: t('schoolViewInformationTableHeaders.schoolUnitCode', { ns: 'schoolAdministration' }), content: s.schoolUnitCode },
                { header: t('genericTableHeaders.active', { ns: 'common' }), content: Helper.active(s.active) },
                { header: t('genericTableHeaders.created', { ns: 'common' }), content: Helper.formatDate(s.created) },
                { header: t('genericTableHeaders.modified', { ns: 'common' }), content: Helper.formatDate(s.modified) },
                { header: t('genericTableHeaders.removed', { ns: 'common' }), content: Helper.formatDate(s?.removed) },
            )
        }

        return (
            <TableVertical
                header={t('commonTableHeaders.information', { ns: 'schoolAdministration' })}
                info={schoolInfo}
                error={school.code === StatusCode.ERROR}
                searching={school.code === StatusCode.PENDING}
            />
        )
    }

    return (<>
        {renderSchoolUnitInfo()}
    </>)
}

export default SchoolUnitViewInfo;
